/* Bunbag V3 uses the current Shopify product, original media and native cart. */
(() => {
  'use strict';
  const disposers = new WeakMap();
  const titleSuffix = document.title.includes(' – ') ? document.title.slice(document.title.lastIndexOf(' – ')) : ' – Wir sind DeiN';
  let requestController, requestNumber = 0;
  let committedUrl = location.href;
  const readProduct = () => JSON.parse(document.getElementById('bunv3-product').textContent);

  async function changeProduct(root, nextUrl, {historyMode='push', closureTitle}={}) {
    const currentProduct = readProduct();
    const currentPath = new URL(committedUrl).pathname;
    const design = root.querySelector('#bunv3-design');
    if (![...design.options].some(option => new URL(option.value, location.origin).pathname === nextUrl.pathname)) return;
    const requestId = ++requestNumber;
    requestController?.abort();
    const controller = new AbortController();
    requestController = controller;
    const timeout = setTimeout(() => controller.abort(), 15000);
    const status = root.querySelector('[data-bun-design-status]');
    const add = root.querySelector('.bun-add');
    const wasDisabled = !currentProduct.variants.find(v => String(v.id) === root.querySelector('[data-bun-variant]').value)?.available;
    root.setAttribute('aria-busy','true');
    status.hidden = false;
    status.textContent = 'Dein Design wird geladen …';
    add.disabled = true;
    root.querySelector('.bun-payment').hidden = true;
    root.querySelectorAll('[name="bun-closure"]').forEach(input => input.disabled = true);
    try {
      const sectionId = root.closest('.shopify-section').id.replace('shopify-section-','');
      const requestUrl = new URL(nextUrl);
      requestUrl.searchParams.set('section_id',sectionId);
      const response = await fetch(requestUrl, {credentials:'same-origin',signal:controller.signal});
      if (!response.ok) throw new Error('Product section unavailable');
      const html = new DOMParser().parseFromString(await response.text(),'text/html');
      if (requestId !== requestNumber) return;
      const incoming = html.querySelector('[data-bun-root]');
      const product = JSON.parse(html.getElementById('bunv3-product')?.textContent || 'null');
      const expectedHandle = nextUrl.pathname.split('/').filter(Boolean).pop();
      if (!incoming || !product || product.handle !== expectedHandle || String(product.id) !== incoming.dataset.productId) throw new Error('Product mismatch');
      const requestedVariant = nextUrl.searchParams.get('variant');
      const variant = product.variants.find(v => String(v.id) === requestedVariant)
        || product.variants.find(v => v.title === closureTitle)
        || product.variants.find(v => v.available) || product.variants[0];
      const anchorTop = design.getBoundingClientRect().top;
      const oldForm = root.querySelector('product-form');
      const newForm = incoming.querySelector('product-form');
      if (!oldForm || !newForm || !variant) throw new Error('Product form missing');

      // Keep the native cart form and its installed accessory-app handlers.
      disposers.get(root)?.();
      root.querySelectorAll('video').forEach(video => video.pause());
      document.getElementById('bunv3-zoom')?.close();
      ['product-id','section-id'].forEach(name => {
        const input = oldForm.querySelector(`[name="${name}"]`);
        const nextInput = newForm.querySelector(`[name="${name}"]`);
        if (input && nextInput) input.value = nextInput.value;
      });
      oldForm.querySelector('.bun-payment').replaceWith(newForm.querySelector('.bun-payment'));
      oldForm.querySelector('[data-bun-variant]').value = variant.id;
      oldForm.querySelector('.product-form__error-message-wrapper').hidden = true;
      newForm.replaceWith(oldForm);
      // These are shop-wide photo reviews; retain the already initialized app.
      incoming.querySelector('#bunv3-reviews')?.replaceWith(root.querySelector('#bunv3-reviews'));
      const productNode = document.getElementById('bunv3-product');
      productNode.textContent = JSON.stringify(product);
      const structuredData = productNode.parentElement.querySelector('script[type="application/ld+json"]');
      const nextStructuredData = html.querySelector('script[type="application/ld+json"]');
      if (structuredData && nextStructuredData) structuredData.textContent = nextStructuredData.textContent;
      nextUrl.searchParams.set('variant',variant.id);
      history[historyMode === 'push' ? 'pushState' : 'replaceState']({...history.state,bunv3:true},'',nextUrl);
      committedUrl = location.href;
      root.replaceWith(incoming);
      document.title = product.title + titleSuffix;
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.href = nextUrl.origin + nextUrl.pathname;
      mount(incoming);
      window.Shopify?.PaymentButton?.init?.();
      const nextDesign = incoming.querySelector('#bunv3-design');
      if (historyMode === 'push') {
        window.scrollBy({top:nextDesign.getBoundingClientRect().top-anchorTop,behavior:'instant'});
        nextDesign.focus({preventScroll:true});
      }
      incoming.dispatchEvent(new CustomEvent('bunv3:product-changed',{bubbles:true,detail:{productId:product.id,variantId:variant.id,url:nextUrl.href}}));
    } catch (error) {
      if (requestId !== requestNumber) return;
      design.value = [...design.options].find(option => new URL(option.value,location.origin).pathname === currentPath)?.value || design.value;
      status.textContent = 'Das Design konnte gerade nicht geladen werden. Bitte wähle es noch einmal aus.';
      if (historyMode === 'none') history.replaceState({...history.state,bunv3:true},'',committedUrl);
    } finally {
      clearTimeout(timeout);
      if (requestId === requestNumber && root.isConnected) {
        root.removeAttribute('aria-busy');
        add.disabled = wasDisabled;
        root.querySelector('.bun-payment').hidden = wasDisabled;
        root.querySelectorAll('[name="bun-closure"]').forEach(input => input.disabled = false);
      }
    }
  }

  function mount(root) {
    if (!root || root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const product = readProduct();
    const listeners = new AbortController();
    const on = (element,type,handler) => element.addEventListener(type,handler,{signal:listeners.signal});
    const q = selector => root.querySelector(selector);
    const qa = selector => [...root.querySelectorAll(selector)];
    const money = amount => new Intl.NumberFormat('de-DE', {style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(amount / 100);
    const qty = q('[name="quantity"]');
    const params = new URLSearchParams(location.search);
    const form=q('product-form form');
    const offers=q('[data-bun-offers]'), commerce=q('[data-bun-commerce]');
    function placeShopApps(){
      if(!offers||!commerce)return;
      form.querySelectorAll('.essential-upsell-addon-container,[data-essential-upsell-element="container"]').forEach(el=>{if(!offers.contains(el))offers.append(el);});
      q('.bun-offers').hidden=!offers.children.length;
      form.querySelectorAll('.free_shipping_card,.ultimateTrustBadgesInnerContainer').forEach(el=>{if(!commerce.contains(el))commerce.append(el);});
    }
    const appObserver=new MutationObserver(placeShopApps);
    if(offers){placeShopApps();appObserver.observe(form,{childList:true,subtree:true});}
    disposers.set(root,()=>{listeners.abort();appObserver.disconnect();});
    const previewKeys = ['preview_theme_id','_ab','_fd','_sc','pb','preview_key','bun_qa'];
    function productUrl(path) {
      const next = new URL(path, location.origin);
      previewKeys.forEach(key => { if (params.has(key)) next.searchParams.set(key,params.get(key)); });
      if (params.get('view') === 'bunbag-v3') next.searchParams.set('view','bunbag-v3');
      return next;
    }
    on(q('#bunv3-design'),'change', event => {
      const next = productUrl(event.target.value);
      const selected = product.variants.find(v => String(v.id) === q('[data-bun-variant]').value);
      if (next.pathname !== new URL(committedUrl).pathname || root.getAttribute('aria-busy') === 'true') changeProduct(root,next,{closureTitle:selected?.title});
    });
    // Preserve an explicitly shared draft context when navigating through the shop.
    if (params.has('preview_theme_id')) {
      document.querySelectorAll('a[href]').forEach(a => {
        const u = new URL(a.href,location.href);
        if (u.origin === location.origin && /^\/(products|collections)\//.test(u.pathname)) {
          previewKeys.forEach(key => { if(params.has(key)) u.searchParams.set(key,params.get(key)); });
          a.href = u.href;
        }
      });
    }
    function variantChanged(id, updateUrl=true) {
      const v = product.variants.find(v => String(v.id) === String(id));
      if (!v) return;
      q('[data-bun-variant]').value = v.id;
      q('[data-bun-variant]').dispatchEvent(new Event('change',{bubbles:true}));
      qa('[name="bun-closure"]').forEach(input => input.checked = String(input.value) === String(v.id));
      qa('[data-bun-price]').forEach(el => el.textContent = money(v.price));
      const compare=q('[data-bun-compare]');
      compare.hidden = !(v.compare_at_price > v.price);
      compare.textContent = v.compare_at_price ? money(v.compare_at_price) : '';
      const button = q('.bun-add');
      button.disabled = !v.available;
      button.setAttribute('aria-disabled',String(!v.available));
      button.querySelector('span').textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      q('.bun-payment').hidden = !v.available;
      q('[data-bun-status]').textContent = `${product.title}, ${v.title}, ${money(v.price)}. ${v.available?'Verfügbar':'Ausverkauft'}.`;
      if (updateUrl) {
        const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({...history.state,bunv3:true},'',u);committedUrl=location.href;
      }
      root.dispatchEvent(new CustomEvent('bunv3:variant',{bubbles:true,detail:{productId:product.id,variantId:v.id}}));
    }
    qa('[name="bun-closure"]').forEach(input => on(input,'change',()=>variantChanged(input.value)));
    qa('[data-quantity]').forEach(button => on(button,'click',()=>{
      qty.value=Math.max(1,(Number(qty.value)||1)+Number(button.dataset.quantity));
      qty.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    on(qty,'change',()=>{if(!Number.isInteger(Number(qty.value))||Number(qty.value)<1)qty.value=1;});
    const panes=qa('[data-gallery-pane]'), buttons=qa('[data-gallery-button]');
    const zoom=document.getElementById('bunv3-zoom');
    let selected=0, opener;
    function setImage(index) {
      selected=(index+panes.length)%panes.length;
      panes.forEach((pane,i)=>{
        pane.hidden=i!==selected;
        if(pane.hidden)pane.querySelectorAll('video').forEach(v=>v.pause());
        else pane.querySelectorAll('img').forEach(img=>img.loading='eager');
      });
      buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===selected)));
      q('[data-gallery-caption]').textContent=panes[selected].dataset.caption;
    }
    buttons.forEach((button,i)=>on(button,'click',()=>setImage(i)));
    on(q('.thumbs'),'keydown',event=>{
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
        event.preventDefault();setImage(selected+(event.key==='ArrowRight'?1:-1));buttons[selected].focus();
      }
    });
    qa('[data-zoom]').forEach(button=>on(button,'click',()=>{
      const img=button.querySelector('img').cloneNode(true);
      img.removeAttribute('sizes');img.removeAttribute('srcset');img.loading='eager';
      zoom.querySelector('[data-zoom-image]').replaceChildren(img);
      opener=button;zoom.showModal();
    }));
    on(zoom.querySelector('[data-zoom-close]'),'click',()=>zoom.close());
    on(zoom,'close',()=>opener?.focus());
    on(zoom,'click',event=>{if(event.target===zoom){const r=zoom.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)zoom.close();}});
    variantChanged(q('[data-bun-variant]').value,false);
    root.dispatchEvent(new CustomEvent('bunv3:ready',{bubbles:true,detail:{productId:product.id}}));
  }
  document.querySelectorAll('[data-bun-root]').forEach(mount);
  window.addEventListener('popstate',()=>{
    const root=document.querySelector('[data-bun-root]');
    if (root) changeProduct(root,new URL(location.href),{historyMode:'none'});
  });
  document.addEventListener('shopify:section:load',event=>mount(event.target.querySelector('[data-bun-root]')));
})();
